module.exports = __webpack_public_path__ + "static/media/side_chain_filter.05f7431c.png";